import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui-kit/themeStyle';
import styled, { css } from 'styled-components';

//Todo: Remove styled component, replace module.css
export const SIMPLE_SURVEY_MAX_WIDTH = 312;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
  max-width: ${SIMPLE_SURVEY_MAX_WIDTH}px;

  align-items: center;
  box-sizing: border-box;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  align-items: center;
  text-align: center;
  gap: var(--spacing-32);
  margin-bottom: var(--spacing-16);
  ${QUERIES.largeTabletAndUp} {
    gap: var(--spacing-48);
    margin-bottom: var(--spacing-24);
  }
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;
  justify-content: center;
  gap: var(--spacing-8);
  ${QUERIES.largeTabletAndUp} {
    padding-bottom: var(--spacing-16);
  }
`;

export const ProgressDot = styled.div<{ active?: boolean }>`
  width: var(--spacing-48);
  height: var(--spacing-4);
  background-color: ${({ active }) =>
    active ? themeStyle.colorBgFillBrand : themeStyle.colorBgFillTertiary};
  transition: background-color ${themeStyle.motionDuration300} ease-in-out;
`;

export const SurveyOption = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  flex-direction: row;

  padding: var(--spacing-16);
  border-radius: var(--border-radius-12);
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  background-color: ${themeStyle.colorBgFillSecondary};
  font-size: var(--font-size-14);
  border: 1px solid transparent;
  width: 100%;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};

  ${QUERIES.largeTabletAndUp} {
    padding: var(--spacing-24);
  }

  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};

  ${({ isDisabled }) =>
    !isDisabled &&
    css`
      &:hover {
        background-color: ${themeStyle.colorBgFillSecondaryHover};
        border-color: ${themeStyle.colorBorderSelector};
      }
    `}
`;

export const SurveyOptionList = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  gap: var(--spacing-8);
`;

export const OptionContent = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  gap: var(--spacing-16);
  justify-content: center;

  /* Icon should not shrink or grow */
  > :first-child:not(p) {
    flex-shrink: 0;
  }

  &:has(> :first-child:not(p)) {
    width: 45%;
    justify-content: flex-start;
  }
`;
